export enum StatusesEnum {
  Quoting = 1,
  Enrollment = 2,
  Submitted = 3,
  Active = 4,
  Termed = 5,
}

export const STATUSES_LABEL = {
  [StatusesEnum.Quoting]: 'Quoting',
  [StatusesEnum.Enrollment]: 'Enrollment',
  [StatusesEnum.Submitted]: 'Submitted',
  [StatusesEnum.Active]: 'Active',
  [StatusesEnum.Termed]: 'Termed',
};
